<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :multi-sort="multiSort"
    :sort-by="sortBy"
    id="control-values"
  >
    <template v-slot:top="{}">
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="675px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="hostingInstitution"
              :to="{ name: 'AddHostingInstitution' }"
              color="black"
              depressed
              rounded
              large
              class="white--text font-weight-bold mb-2"
            >
              <v-icon color="white">
                $vuetify.icons.plus
              </v-icon>
              Add New
            </v-btn>
            <v-btn
              v-else
              color="black"
              depressed
              rounded
              large
              class="white--text font-weight-bold mb-2"
              v-bind="attrs"
              v-on="on"
              @click="$refs.form ? $refs.form.resetValidation() : null"
            >
              <v-icon color="white">
                $vuetify.icons.plus
              </v-icon>
              Add New
            </v-btn>
          </template>
          <v-card
            class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
          >
            <v-card-title class="px-2">
              <v-row class="mx-0 px-0 px-sm-2 px-lg-2 px-xl-2 px-md-2" align="center">
                <v-col
                  cols="10"
                  sm="11"
                  xl="11"
                  lg="11"
                  md="11"
                  class="text-center d-flex justify-center align-center"
                >
                  {{ formTitle }}
                </v-col>
                <v-col cols="1">
                  <v-btn fab small text @click="close">
                    <v-icon color="neutral500">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="my-2 my-sm-6 my-xl-6 my-lg-6 my-md-6"></v-divider>
            <v-card-text>
              <v-form ref="form" v-model="valid" :lazy-validation="false">
                <slot name="form" :editedItem="editedItem"></slot>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-row style="width: 100%">
                <v-col cols="6">
                  <v-btn
                    block
                    depressed
                    rounded
                    large
                    class="neutral800--text font-weight-bold"
                    color="neutral"
                    outlined
                    @click="close"
                    >{{ $t('cancel') }}
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    :disabled="!valid"
                    block
                    depressed
                    rounded
                    large
                    class="white--text font-weight-bold"
                    color="black"
                    @click="save"
                    >{{ $t('save') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="675px">
          <v-card
            class="py-2 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
          >
            <v-card-title class="px-0 py-0">
              <v-row class="mx-0 px-2" align="center">
                <v-col cols="11" class="text-center d-flex justify-center align-center">
                  {{ $t('delete.message') }}
                </v-col>
                <v-col cols="1" class="pl-0">
                  <v-btn fab small text @click="dialogDelete = false">
                    <v-icon color="neutral500">
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
            <v-divider class="my-1 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
            <v-card-text>
              <v-row class="mx-0 px-2" align="center">
                <v-col cols="12" class="text-center d-flex justify-center align-center">
                  {{ $t('delete.confirm') }}
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row style="width: 100%">
                <v-col cols="6">
                  <v-btn
                    block
                    depressed
                    rounded
                    large
                    class="neutral800--text font-weight-bold"
                    color="neutral"
                    outlined
                    @click="closeDelete"
                    >{{ $t('cancel') }}
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    block
                    depressed
                    rounded
                    large
                    class="white--text font-weight-bold"
                    color="red darken-1"
                    @click="deleteItemConfirm"
                    >{{ $t('delete.message') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="actions">
        <v-icon v-if="hostingInstitution" small class="mr-2" @click="editHostingInstitution(item)">
          mdi-pencil-outline
        </v-icon>
        <v-icon v-else small class="mr-2" @click="editItem(item)">
          mdi-pencil-outline
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete-outline
        </v-icon>
      </div>
    </template>
    <template v-slot:no-data>
      Loading...
    </template>
  </v-data-table>
</template>

<script>
import EventBus from '@/helpers/event-bus';

export default {
  name: 'TableControlValue',
  props: {
    headers: Array,
    value: Array,
    label: {
      type: String,
      default: 'Item',
    },
    defaultItem: {
      type: Object,
      default: () => {},
    },
    sortBy: {
      type: String,
      default: null,
    },
    urlApi: String,
    multiSort: {
      type: Boolean,
      default: false,
    },
    hostingInstitution: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    valid: false,
    dialog: false,
    dialogDelete: false,
    items: [],
    editedIndex: -1,
    editedItem: {},
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New ' + this.label : 'Edit ' + this.label;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.axios.get(this.urlApi).then(res => (this.items = res.data.content));
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      console.log('Click Delete ' + this.editedIndex);
      EventBus.$emit('waiting', true);
      this.axios
        .delete(this.urlApi + '/' + this.editedItem.id)
        .then(() => {
          console.log('Success');
          this.items.splice(this.editedIndex, 1);
          this.closeDelete();
          EventBus.$emit('snackbar', {
            text: this.$i18n.t('delete.success'),
          });
        })
        .catch(error => {
          console.log(error);
        })
        .finally(EventBus.$emit('waiting', false));
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      EventBus.$emit('waiting', true);
      this.axios
        .post(this.urlApi, this.editedItem)
        .then(res => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: 'Success',
          });
          this.editedItem.id = res.data.id;
          if (this.editedIndex > -1) {
            Object.assign(this.items[this.editedIndex], this.editedItem);
          } else {
            this.items.push(this.editedItem);
          }
          this.close();
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    editHostingInstitution(item) {
      this.$router.push({ name: 'EditHostingInstitution', params: { id: item.id } });
    },
  },
};
</script>
